const query = q => document.querySelector(q)

import {
  BaseFieldValidator
} from './base-validator'

const GLOBAL_INFO = "Campo inválido";
const EMAIL_RE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const data = [
  {
    target: '[data-input-person-name]',
  }
]
const basePerson = new BaseFieldValidator(data)

const result = basePerson.run() 

export function basePersonValidator(props) {

  let errors = [];

  const { name, email, phone_number } = props;
  const DOMElements = [
    query("[data-base-person-name]"),
    query("[data-base-person-email]"),
    query("[data-base-person-phone-number]")
  ];
  const invalidField = (field, info, index = 0) => {
  }
  const validField = (field, index) => {
  }


  if (!name) {
    invalidField("[data-base-person-name-info]", GLOBAL_INFO, 0)
  } else {
    validField("[data-base-person-name-info]", 0)
  }

  if (!email) {
    invalidField("[data-base-person-email-info]", "Email não pode ser vazio", 1)

  } else {
    var re = EMAIL_RE
    if (!re.test(email.toLowerCase())) {
      invalidField("[data-base-person-email-info]", "Email inválido", 1)
    } else {
      validField("[data-base-person-email-info]", 1)
    }
  }
  if (!phone_number) {
    invalidField("[data-base-person-phone-number-info]", GLOBAL_INFO, 2)
  } else {
    validField("[data-base-person-phone-number-info]", 2)
  }

  console.log(errors);


  return errors;
}



// WEBPACK FOOTER //
// ./src/components/parts/utils/base-person-validators.js